import { ELinkVariant, Link } from '@outdoorsyco/bonfire';
import React from 'react';

import { DISCLAIMER_LINKS } from '@/constants/checkout';

type TTermsLinkProps = {
  variant?: ELinkVariant;
  children: React.ReactNode;
};

const TermsLink: React.FC<TTermsLinkProps> = ({ variant = ELinkVariant.Underline, children }) => (
  <Link href={DISCLAIMER_LINKS.TERMS} variant={variant} target="_blank">
    {children}
  </Link>
);

export default TermsLink;
